import {
  SuburbsGeocodingLocalDatasource,
  LocalGeocodeRepository,
  LocalGeocodingResponseModel,
  LocalGeocodingResponseFeature,
} from '@/features/hazards';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSuburbGeocodeStore = defineStore('suburbGeocodeStore', () => {
  // TODO: refact to use entity instead of model
  const geocoding = ref<LocalGeocodingResponseModel>();
  const geocodedSuburb = ref<LocalGeocodingResponseFeature>();

  const suburbDataSource = new SuburbsGeocodingLocalDatasource();
  const geocodeRepository = new LocalGeocodeRepository(suburbDataSource);

  const isLoading = ref(false);

  const clearGeocoding = () => (geocoding.value = undefined);

  const clearGeocodedSuburb = () => (geocodedSuburb.value = undefined);

  const getForwardGeocoding = (query: string) => {
    isLoading.value = true;

    geocoding.value = geocodeRepository.getForwardGeocoding(query);

    isLoading.value = false;
  };

  const getGeocodingById = async (id: number) => {
    isLoading.value = true;

    geocodedSuburb.value = geocodeRepository.getGeocodingById(id);

    isLoading.value = false;
  };

  return {
    isLoading,
    geocoding,
    geocodedSuburb,
    clearGeocoding,
    clearGeocodedSuburb,
    getForwardGeocoding,
    getGeocodingById,
  };
});
